//控件的方向值
export enum ControlAnchor {
  BMAP_ANCHOR_TOP_LEFT,
  BMAP_ANCHOR_TOP_RIGHT,
  BMAP_ANCHOR_BOTTOM_LEFT,
  BMAP_ANCHOR_BOTTOM_RIGHT
}

//地图密钥
export const BMAPKEY = 'gi4p8Ykl38RyyccO5pb4waSQtHdIYBdI'
export const AMAPKEY = '31b8a4e3cdd8bf0a98ec87120e439e3b';

//默认地址 北京市经纬度坐标
export const defaultPoint = {
  lng: 116.46,
  lat: 39.92
}


export const MAP_TYPES = {
  aMap: 'aMap', //高德地图
  bMap: 'bMap' //百度地图
}

export const MAP_TYPE = MAP_TYPES.bMap;

//地图层级对应的比例尺(单位为m)
export const mapLevel = {
  19: 20,
  18: 50,
  17: 100,
  16: 200,
  15: 500,
  14: 1000,
  13: 2000,
  12: 2000,
  11: 5000,
  10: 10000,
  9: 20000
}

//设备定位类型
export const locationType = {
  gps: 1, //卫星定位
  wifi: 2, //wifi定位
  lbs: 3 //基站定位（模糊定位）
}